/**
 * Real-time notification utilities
 */
import { toast } from "sonner";

/**
 * Show notification based on application status change
 */
export const showStatusNotification = (status, applicationId) => {
  switch (status) {
    case 'approved':
      toast.success(`🎉 Great news! Your loan application has been approved!`, {
        description: `Application ID: ${applicationId?.slice(0, 20)}...`,
        duration: 8000,
      });
      break;
    case 'rejected':
      toast.error(`Your loan application decision is ready.`, {
        description: `Please check your dashboard for details.`,
        duration: 8000,
      });
      break;
    case 'recommended':
      toast.info(`Your application is being reviewed by a manager.`, {
        description: `We'll notify you once a decision is made.`,
        duration: 6000,
      });
      break;
    case 'escalated':
      toast.info(`Your application has been escalated for executive review.`, {
        description: `This is for loans requiring additional approval.`,
        duration: 6000,
      });
      break;
    case 'under_review':
      toast.info(`Your application is now under review.`, {
        description: `Our team is analyzing your application.`,
        duration: 5000,
      });
      break;
    default:
      break;
  }
};

/**
 * Show notification for back-office users about new/updated applications
 */
export const showBackOfficeNotification = (type, data) => {
  switch (type) {
    case 'new_application':
      toast.info(`📋 New application submitted`, {
        description: `Amount: $${data.amount?.toLocaleString() || 'N/A'} - ${data.business_name || data.applicant_name || 'New Applicant'}`,
        duration: 6000,
      });
      break;
    case 'escalated':
      toast.warning(`⬆️ Application escalated for executive review`, {
        description: `Application ${data.application_id?.slice(0, 15)}... requires executive approval`,
        duration: 8000,
      });
      break;
    case 'decision_made':
      toast.success(`✅ Decision recorded`, {
        description: `Application ${data.decision} - notification sent to applicant`,
        duration: 5000,
      });
      break;
    default:
      break;
  }
};

/**
 * Show welcome back notification with pending items
 */
export const showWelcomeNotification = (user, pendingCount = 0) => {
  if (pendingCount > 0) {
    toast.info(`Welcome back, ${user.name}!`, {
      description: `You have ${pendingCount} application(s) pending review.`,
      duration: 5000,
    });
  } else {
    toast(`Welcome back, ${user.name}!`, {
      duration: 3000,
    });
  }
};

/**
 * Check for application status updates on login
 */
export const checkApplicationUpdates = async (applications, lastLogin) => {
  if (!applications || !lastLogin) return;
  
  const lastLoginDate = new Date(lastLogin);
  
  applications.forEach(app => {
    const updatedAt = new Date(app.updated_at || app.created_at);
    if (updatedAt > lastLoginDate && app.status !== 'pending') {
      showStatusNotification(app.status, app.application_id);
    }
  });
};

export default {
  showStatusNotification,
  showBackOfficeNotification,
  showWelcomeNotification,
  checkApplicationUpdates,
};
